<template>
  <v-app class="disable-favorites">
    <router-view />
    <err-dialog />
  </v-app>
</template>

<script>
import dialog from "./dialog.vue";
import "moodleDir/procollege/lib/style/styleTabs.css";
export default {
  name: "App",
  components: {
    "err-dialog": dialog,
  },
  created() {

  }
};
</script>
<style>
.v-application--wrap {
  min-height: 100px !important;
}
/**
secondary-navigation 60px default, даже если пустая
*/
.moremenu{
  height: auto;
}
</style>